module.exports = __webpack_public_path__ + "img/2-2.31a2e802.png";